import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

export const useAdminSession = () => {
  const [authed, setAuthed] = useState(null);
  useEffect(() => {
    api.get("/admin/me").then(() => setAuthed(true)).catch(() => setAuthed(false));
  }, []);
  const logout = async () => { await api.post("/admin/logout").catch(() => {}); setAuthed(false); };
  return { authed, setAuthed, logout };
};

export const useAdminData = () => {
  const [overview, setOverview] = useState(null);
  const [bookings, setBookings] = useState([]);
  const [waitlist, setWaitlist] = useState([]);

  const load = useCallback(async () => {
    const [o, b, w] = await Promise.all([api.get("/admin/overview"), api.get("/admin/bookings"), api.get("/admin/waitlist")]);
    setOverview(o.data); setBookings(b.data); setWaitlist(w.data);
  }, []);

  useEffect(() => { load(); }, [load]);

  const setStatus = async (id, status) => {
    if (status === "cancelled" && !window.confirm("Cancel this booking?")) return;
    await api.patch(`/admin/bookings/${id}/status`, { status });
    await load();
  };

  return { overview, bookings, waitlist, setStatus };
};

export const downloadCsv = async (path, name) => {
  const r = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = Object.assign(document.createElement("a"), { href: url, download: name });
  a.click();
  URL.revokeObjectURL(url);
};

export const filterBookings = (bookings, q) =>
  bookings.filter((b) => !q || [b.reference, b.name, b.email, b.phone, b.address, b.zip].join(" ").toLowerCase().includes(q.toLowerCase()));
